// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"44f8238a","239":"dfdb0d71","732":"0eb8fd42","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};